import { CurrentBreakpoint } from 'hooks/useGetCurrentBreakpoint/useGetCurrentBreakpoint';

export enum DetailsViewSizes {
    xs,
    sm,
    md,
    ml,
    lg,
    xl,
}

const breakpointToSize: { [key: string]: DetailsViewSizes } = {
    xs: DetailsViewSizes.sm,
    sm: DetailsViewSizes.sm,
    ms: DetailsViewSizes.sm,
    md: DetailsViewSizes.md,
    ml: DetailsViewSizes.ml,
    lg: DetailsViewSizes.lg,
    xl: DetailsViewSizes.lg,
    xxl: DetailsViewSizes.xl,
    jb: DetailsViewSizes.xl,
    default: DetailsViewSizes.xl,
    unknown: DetailsViewSizes.xl,
};

export const getDetailsViewSizes = ({
    currentBreakpoint,
}: {
    currentBreakpoint: CurrentBreakpoint;
}) => {
    const currentSize: DetailsViewSizes = breakpointToSize[currentBreakpoint];

    const isSm = currentSize <= DetailsViewSizes.sm;
    const isMd = currentSize <= DetailsViewSizes.md;
    const isMl = currentSize <= DetailsViewSizes.ml;
    const isLg = currentSize <= DetailsViewSizes.lg;
    const isXl = currentSize <= DetailsViewSizes.xl;

    return { isSm, isMd, isMl, isLg, isXl };
};
